import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createSlots as _createSlots, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04c940ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-menu-horizontal-warp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubItem = _resolveComponent("SubItem")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_scrollbar, {
      onWheel: _withModifiers(_ctx.onElMenuHorizontalScroll, ["prevent"]),
      ref: "elMenuHorizontalScrollRef"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          router: "",
          "default-active": _ctx.defaultActive,
          "background-color": "transparent",
          mode: "horizontal"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuLists, (val) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (val.children && val.children.length > 0)
                  ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                      index: val.path,
                      key: val.path
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(val.meta.icon ? val.meta.icon : '')
                        }, null, 2),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(val.meta.title)), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_SubItem, {
                          chil: val.children
                        }, null, 8, ["chil"])
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  : (_openBlock(), _createBlock(_component_el_menu_item, {
                      index: val.path,
                      key: val.path
                    }, _createSlots({ _: 2 }, [
                      (!val.meta.isLink || (val.meta.isLink && val.meta.isIframe))
                        ? {
                            name: "title",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(val.meta.icon ? val.meta.icon : '')
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(val.meta.title)), 1)
                            ])
                          }
                        : {
                            name: "title",
                            fn: _withCtx(() => [
                              _createElementVNode("a", {
                                href: val.meta.isLink,
                                target: "_blank",
                                rel: "opener"
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(val.meta.icon ? val.meta.icon : '')
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t(val.meta.title)), 1)
                              ], 8, ["href"])
                            ])
                          }
                    ]), 1032, ["index"]))
              ], 64))
            }), 256))
          ]),
          _: 1
        }, 8, ["default-active"])
      ]),
      _: 1
    }, 8, ["onWheel"])
  ]))
}